import React from 'react';
import { useFragment } from 'react-relay/hooks';

import { createStyles, WithStyles, withStyles } from '@material-ui/core';
import TableRow, { TableRowProps } from '@material-ui/core/TableRow';
import { graphql } from 'babel-plugin-relay/macro';
import { get } from 'lodash';
import moment from 'moment';

import { TableCell } from 'components/v2';

import { TableRowMessage_Message$key } from './__generated__/TableRowMessage_Message.graphql';
import IconMessageStatus from './IconMessageStatus';
import TypographyMessageChannel from './TypographyMessageChannel';
import TypographyMessageRef from './TypographyMessageRef';
import TypographyMessageText from './TypographyMessageText';

const styles = () =>
  createStyles({
    cellDate: {
      width: 175,
    },
    cellStatus: {
      width: 80,
    },
  });

export interface TableRowMessageProps extends Omit<TableRowProps, 'classes'>, WithStyles<typeof styles> {
  fragmentRef: TableRowMessage_Message$key;
}

const TableRowMessage: React.FC<TableRowMessageProps> = ({ classes, fragmentRef, ...rest }) => {
  const message = useFragment<TableRowMessage_Message$key>(
    graphql`
      fragment TableRowMessage_Message on Message {
        _id
        createdAt
        patient {
          _id
          name
        }
        from
        to
        ...TypographyMessageText_Message
        ...TypographyMessageChannel_Message
        ...TypographyMessageRef_Message
        ...IconMessageStatus_Message
      }
    `,
    fragmentRef,
  );

  return (
    <TableRow {...rest}>
      <TableCell className={classes.cellDate} noWrap>
        {moment(message.createdAt as string).format('lll')}
      </TableCell>
      <TableCell noWrap href={`/patients/${get(message, 'patient._id')}/chat`}>
        {get(message, 'patient.name')}
      </TableCell>
      <TableCell noWrap>{message.from}</TableCell>
      <TableCell noWrap>{message.to}</TableCell>
      <TableCell noWrap>
        <TypographyMessageText fragmentRef={message} variant="inherit" includePopper noWrap />
      </TableCell>
      <TableCell>
        <TypographyMessageChannel fragmentRef={message} variant="inherit" />
      </TableCell>
      <TableCell noWrap>
        <TypographyMessageRef fragmentRef={message} variant="inherit" />
      </TableCell>
      <TableCell className={classes.cellStatus}>
        <IconMessageStatus fragmentRef={message} fontSize="small" />
      </TableCell>
    </TableRow>
  );
};

export default withStyles(styles)(TableRowMessage);
